import {
  GetCustomizeCar_customizeCar,
  GetCustomizeCar_customizeCar_availableFeatures,
} from '../graphql/queries/__generated__/GetCustomizeCar';
import CategoryPurpose from '../enum/CategoryPurpose';

const similarStockCarsService = {
  getFeatureFromCode(
    featureCodes: string[],
    selectedCar: GetCustomizeCar_customizeCar,
    categoryPurpose: CategoryPurpose,
  ): GetCustomizeCar_customizeCar_availableFeatures {
    const { availableFeatureCategories, availableFeatures } = selectedCar || {};

    let featureFromCode: GetCustomizeCar_customizeCar_availableFeatures | null = null;
    featureCodes.some(code => {
      const availableFeature = availableFeatures?.find(f => f.code === code);
      if (availableFeature) {
        const category = availableFeatureCategories?.find(f => f.code === availableFeature.categoryCode);
        if (category?.attributes.categorypurpose === categoryPurpose) {
          featureFromCode = availableFeature;

          return true;
        }
      }

      return false;
    });

    return featureFromCode;
  },

  getSelectedFeaturesWithoutColors(customizeCar: GetCustomizeCar_customizeCar, selectedFeatures: string[]): string[] {
    const interiorColorCode = this.getFeatureFromCode(
      selectedFeatures,
      customizeCar,
      CategoryPurpose.INTERIOR_COLOUR,
    )?.code;
    const exteriorColorCode = this.getFeatureFromCode(
      selectedFeatures,
      customizeCar,
      CategoryPurpose.EXTERIOR_COLOUR,
    )?.code;
    const roofAndMirror = this.getFeatureFromCode(selectedFeatures, customizeCar, CategoryPurpose.ROOFANDMIRROR)?.code;
    const customizeCarColors = [interiorColorCode, exteriorColorCode, roofAndMirror];

    return selectedFeatures.filter(featureCode => !customizeCarColors.includes(featureCode));
  },
};

export default similarStockCarsService;
